import { Modal } from "antd";
import { ICCheckCircleOutlined } from "components/list/ListIcon";

const { success } = Modal;

const ModalConfirmDeleteSuppress = (props) => {
  const { okButtonProps, customMessage, message } = props;
  const messageModal = customMessage || <p className="mb-0">{message}</p>;
  return success({
    ...props,
    icon: <ICCheckCircleOutlined style={{ color: "#18C753" }} />,
    content: messageModal,
    centered: true,
    okButtonProps: { ...okButtonProps },
    autoFocusButton: null,
    width: 416,
  });
};

export default ModalConfirmDeleteSuppress;
